import Lenis from "lenis";

export const WHATSAPP = (process.env.REACT_APP_WHATSAPP_NUMBER || "").replace(/\D/g, "");
export const INSTAGRAM_URL = "https://www.instagram.com/jlnexus.digital/";
export const EMAIL = "suporte@jlnexusdigital.com";
export const waLink = (text) => (WHATSAPP ? `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(text)}` : "");

let lenis = null;

export const startLenis = () => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return () => {};
  lenis = new Lenis({ duration: 1.15, smoothWheel: true });
  let id = requestAnimationFrame(function raf(t) {
    lenis?.raf(t);
    id = requestAnimationFrame(raf);
  });
  return () => {
    cancelAnimationFrame(id);
    lenis?.destroy();
    lenis = null;
  };
};

export const setScrollLock = (locked) => {
  if (lenis) locked ? lenis.stop() : lenis.start();
  document.body.style.overflow = locked ? "hidden" : "";
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return false;
  if (lenis) lenis.scrollTo(el, { offset: id === "inicio" ? 0 : -72, force: true });
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
  return true;
};

export const handleAnchor = (e, id) => {
  if (scrollToId(id)) {
    e.preventDefault();
    if (window.location.protocol !== "file:") window.history.replaceState(null, "", `#${id}`);
  }
};
